export default "__VITE_ASSET__Dl8n8BTf__"